import React, { CSSProperties } from 'react'
import { Modal as MUIModal, ModalProps as MUIModalProps } from '@mui/material'
import Paper from '../paper'

export type ModalProps = MUIModalProps

const Modal: React.FC<ModalProps> = ({
  children,
  sx,
  ...rest
}) => {
  const modalStyle: CSSProperties = {
    marginTop: '10%',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '80%'
  }

  return (
    <MUIModal sx={{
      ...modalStyle,
      ...sx
    }} {...rest}>
      <Paper sx={{ padding: 4 }}>
        {children}
      </Paper>
    </MUIModal>
  )
}

export default Modal
